import { memo } from "react";
import { ChevronRightIcon, HomeIcon, Link, useCanShow } from "@";

const Breadcrumb = memo(({ links }) => {
  if (!links) return null;

  return (
    <nav
      className="mb-5 mt-6 inline-flex w-fit items-center rounded-2xl border border-gray-100 bg-white/70 px-3 py-2 text-sm shadow-sm shadow-gray-900/[0.02] backdrop-blur-md dark:border-gray-700/60 dark:bg-gray-800/60 md:mb-7 print:hidden"
      aria-label="Breadcrumb"
    >
      <ol className="flex flex-wrap items-center gap-1.5 font-medium">
        <li className="flex items-center">
          <Link
            to={useCanShow("statistics") ? "/" : "#"}
            className="group/crumb flex items-center gap-1.5 rounded-2xl px-2 py-1 text-gray-500 transition-colors hover:bg-purple-50 hover:text-purple-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-purple-300"
          >
            <HomeIcon className="h-4 w-4 transition-transform group-hover/crumb:-translate-y-0.5 md:h-[18px] md:w-[18px]" />
            <span>الرئيسية</span>
          </Link>
        </li>
        {links.map(({ name, link }, index) => {
          const isLast = index === links.length - 1;
          return (
            <li key={name} className="flex items-center gap-1.5">
              <ChevronRightIcon
                aria-hidden
                className="h-3.5 w-3.5 text-gray-300 dark:text-gray-600 rtl:rotate-180"
                strokeWidth={2.5}
              />
              <Link
                to={link || "#"}
                className={`rounded-2xl px-2 py-1 capitalize transition-colors ${
                  isLast
                    ? "bg-purple-50 font-semibold text-purple-900 dark:bg-purple-950/50 dark:text-purple-300"
                    : link
                      ? "text-gray-500 hover:bg-purple-50 hover:text-purple-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-purple-300"
                      : "cursor-default text-gray-400 opacity-60 dark:text-gray-500"
                }`}
              >
                {name}
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
});

export default Breadcrumb;
